import { createApiClient } from 'Network/ApiClient';

export const SpecialtyAxiosInstance = createApiClient('Specialty/');